/**
 * Show More or Less of a String
 */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { uiState } from 'react-redux-ui-state';
import { withStyles } from '@material-ui/core';

const propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({
    break: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
  lessChars: PropTypes.number,
  string: PropTypes.string.isRequired,
  setUiState: PropTypes.func.isRequired,
  more: PropTypes.bool.isRequired,
};

const defaultProps = {
  className: null,
  lessChars: 80,
};

export function UnstyledMoreLessString({
  className,
  classes,
  lessChars,
  string,
  setUiState,
  more,
}) {
  const toggleClick = () => {
    setUiState({ more: !more });
  };

  let displayString = string;

  if (!more) {
    displayString = string.slice(0, lessChars);
    displayString = `${displayString}...`;
  }

  return (
    <span className={className}>
      <span className={classes.break}>{displayString}</span>
      <Button type="button" tabIndex={0} className={classes.link} onClick={toggleClick}>
        {more ? 'less' : 'more'}
      </Button>
    </span>
  );
}

UnstyledMoreLessString.propTypes = propTypes;
UnstyledMoreLessString.defaultProps = defaultProps;

const styles = () => ({
  break: {
    display: 'inline-block',
    whiteSpace: 'pre-wrap' /* css-3 */,
    whiteSpace: '-moz-pre-wrap' /* Mozilla, since 1999 */, // eslint-disable-line no-dupe-keys
    whiteSpace: '-pre-wrap' /* Opera 4-6 */, // eslint-disable-line no-dupe-keys
    whiteSpace: '-o-pre-wrap' /* Opera 7 */, // eslint-disable-line no-dupe-keys
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-all' /* Check this on Safari */,
  },
  link: {
    marginLeft: '.5em',
    color: 'blue',
    background: 'none',
    border: 'none',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    minHeight: 'inherit',
    padding: 0,
    margin: 0,
    textTransform: 'lowercase',
  },
});

export const uiConfig = {
  name: 'moreOrLessString',
  state: () => ({
    more: false,
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledMoreLessString));
